import { render, staticRenderFns } from "./SolicitorDetails.vue?vue&type=template&id=25c779d2"
import script from "./SolicitorDetails.vue?vue&type=script&lang=js"
export * from "./SolicitorDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports